/** Credentials never fall back to volatile memory: a guest must remain recoverable. */
export class StorageUnavailableError extends Error {
  readonly code = "STORAGE_UNAVAILABLE";
  constructor() { super("Allow this site to save browser data, then try signing in again."); this.name = "StorageUnavailableError"; }
}

export function readStorage(key: string, scope: "local" | "session" = "local"): string | null {
  try { return (scope === "local" ? localStorage : sessionStorage).getItem(key); } catch { return null; }
}

export function writeStorage(key: string, value: string): void {
  try { localStorage.setItem(key, value); } catch { throw new StorageUnavailableError(); }
}

export function removeStorage(key: string, scope: "local" | "session" = "local"): boolean {
  try { (scope === "local" ? localStorage : sessionStorage).removeItem(key); return true; } catch { return false; }
}

export function requireCredentialStorage(): void {
  const key = `gameglee.web.storageProbe.${crypto.randomUUID()}`;
  try {
    localStorage.setItem(key, key);
    if (localStorage.getItem(key) !== key) throw new StorageUnavailableError();
  } catch { throw new StorageUnavailableError(); }
  finally { removeStorage(key); }
}
